import React, { useState } from "react";
import Modal from "./Modal";
import penelope from "../../assets/Logo Waving.gif";
import { TOUR_FORM_ENDPOINT, SCHOOL_EMAIL, SCHOOL_PHONE, SCHOOL_PHONE_LINK } from "../../config";
import "./tourRequestModal.css";

const PROGRAMS = ["Toddlers (1 year)", "Two's", "Three's", "VPK (4 years)", "Not sure yet"];

// Without a configured endpoint, hand the request to the visitor's email app instead.
function openEmailApp(data) {
  const body = [
    `Parent name: ${data.name}`,
    `Phone: ${data.phone}`,
    `Email: ${data.email}`,
    `Program: ${data.program}`,
    `Preferred day: ${data.date || "Flexible"}`,
    "",
    data.message,
  ].join("\n");
  window.location.href = `mailto:${SCHOOL_EMAIL}?subject=${encodeURIComponent(
    "Tour request"
  )}&body=${encodeURIComponent(body)}`;
}

export default function TourRequestModal({ onClose }) {
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    if (form.get("website")) return; // honeypot: real people never fill this in

    const data = Object.fromEntries(form.entries());

    if (!TOUR_FORM_ENDPOINT) {
      openEmailApp(data);
      setStatus("sent");
      return;
    }

    setStatus("sending");
    try {
      const res = await fetch(TOUR_FORM_ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ ...data, _subject: `Tour request from ${data.name}` }),
      });
      setStatus(res.ok ? "sent" : "error");
    } catch {
      setStatus("error");
    }
  };

  return (
    <Modal onClose={onClose} label="Schedule a tour" width={520}>
      <div className="tourform-card">
        {status === "sent" ? (
          <div className="tourform-thanks">
            <img src={penelope} alt="Penelope the hippo waving" />
            <h2>Thank you!</h2>
            <p>We can't wait to meet you. We'll reach out soon to confirm your tour.</p>
            <button className="btn btn-purple" onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <>
            <div className="tourform-head">
              <img src={penelope} alt="" />
              <div>
                <h2>Schedule a Tour</h2>
                <p>Come see our classrooms and meet our teachers.</p>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <label>
                Your name
                <input name="name" type="text" required autoComplete="name" autoFocus />
              </label>
              <div className="tourform-row">
                <label>
                  Phone
                  <input name="phone" type="tel" required autoComplete="tel" />
                </label>
                <label>
                  Email
                  <input name="email" type="email" required autoComplete="email" />
                </label>
              </div>
              <div className="tourform-row">
                <label>
                  Program of interest
                  <select name="program" defaultValue={PROGRAMS[4]}>
                    {PROGRAMS.map((p) => (
                      <option key={p}>{p}</option>
                    ))}
                  </select>
                </label>
                <label>
                  Preferred day
                  <input name="date" type="date" />
                </label>
              </div>
              <label>
                Anything we should know? (optional)
                <textarea name="message" rows="3" />
              </label>
              {/* Honeypot for spam bots; hidden from people */}
              <input className="tourform-hp" name="website" tabIndex="-1" autoComplete="off" aria-hidden="true" />
              {status === "error" && (
                <p className="tourform-error" role="alert">
                  Something went wrong. Please call us at{" "}
                  <a href={SCHOOL_PHONE_LINK}>{SCHOOL_PHONE}</a> instead.
                </p>
              )}
              <button className="btn btn-pink" type="submit" disabled={status === "sending"}>
                {status === "sending" ? "Sending..." : "Request My Tour"}
              </button>
            </form>
          </>
        )}
      </div>
    </Modal>
  );
}
